import { render, staticRenderFns } from "./Quiz.vue?vue&type=template&id=7155f238&scoped=true&"
import script from "./Quiz.vue?vue&type=script&lang=ts&"
export * from "./Quiz.vue?vue&type=script&lang=ts&"
import style0 from "./Quiz.vue?vue&type=style&index=0&id=7155f238&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7155f238",
  null
  
)

export default component.exports